module.exports = __webpack_public_path__ + "img/45.b430535e.jpg";